<template>
  <div class="search-module" :class="displaychoice">
  <div class="search-module__header">
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=2">


      <h1 class="text-t1 mb-4">Sök ledigt</h1>
      <p v-if="webapp_config.msg.intro" class="search-module__preamble" v-html="webapp_config.msg.intro"></p>
      <a class="search-module__link" href="/hyr-bostad/sa-gar-det-till-att-hyra-bostad/">Så går det till att hyra hos oss</a>

      <SearchType @change="clear()" :value="searchtype"/>
    </div>
    <div class="search-module__wrapper">
      <div class="search-module__main-container">
        <div class="search-module__info object-desktop">
          <div class="search-module__info__result-count"><span v-if="initalLoad && ((result.length>0 && displaychoice=='list') || displaychoice=='map')">{{ result.length }} objekt</span>
          </div>
          <div class="flex-row search-module__displaychoice">
            <Sort v-if="displaychoice=='list'" v-model="sortBy"/>
            <DisplayChoice v-model="displaychoice"/>
          </div>
        </div>
        <div class="search-module__flex-container">
          <div class="filter-controls apartments search-wrapper">
            <!--v-if="authStatus && (!this.subscriptionCode && this.$route.name != 'SearchPrefill')" :disabled="!numFilters" -->
            <CreateForm :showNew="isExpanded" @close="isExpanded=false" @done="isExpanded=false"/>

            <button v-if="authStatus" class="btn-subscribe btn-subscribe--desktop"
                    @click="isExpanded = !isExpanded">Skapa bevakning
            </button>

            <SearchField v-model="filters.keyword"/>

            <TownDistricts class="vacantApartments" :searchtype="searchtype"
                           v-model="filters.administrativeUnitAreas" :allObjects="unfiltered"/>

            <div v-bind:class="[showFilter ? 'showFilter' : '', 'filterAccordion']">

              <div
                v-if="searchtype == RENTALOBJECT_TYPES.APARTMENT || searchtype == RENTALOBJECT_TYPES.STUDENT_APARTMENT"
                class="vacantApartments">
                <div class="mt-6">
                  <ObjectTypes
                    v-if="searchtype === RENTALOBJECT_TYPES.APARTMENT"
                    class="filter__objectType"
                    v-model="filters.rentalObjectTypes"
                    :activeFilters="filters"
                    :type="RENTALOBJECT_TYPES.APARTMENT"
                    :allObjects="unfiltered"
                  />

                  <div class="form-group">
                    <label for="areaMin">Antal rum</label>
                    <div class="flex-row align-center">
                      <Rooms type="min" v-model="filters.minRooms" :max="filters.maxRooms"/>
                      <div class="filter-line"></div>
                      <Rooms type="max" v-model="filters.maxRooms" :min="filters.minRooms"/>
                    </div>
                  </div>
                  <div class="form-group mt-6">
                    <label for="roomCountMin">Boendeyta (m<sup>2</sup>)</label>
                    <div class="flex-row align-center">
                      <ObjectArea type="min" v-model="filters.minArea" :max="filters.maxArea" :activeType="searchtype"/>
                      <div class="filter-line"></div>
                      <ObjectArea type="max" v-model="filters.maxArea" :min="filters.minArea" :activeType="searchtype"/>
                    </div>
                  </div>
                  <div class="form-group" style="margin-top: 22px">
                    <label for="monthRent">Maxhyra</label>
                    <Rent v-model="filters.maxRent" :activeType="searchtype"/>
                  </div>
                </div>
              </div>
              <div v-if="searchtype == RENTALOBJECT_TYPES.APARTMENT" class="vacantApartments form-group">
                <FastAccess v-model:checked="filters.fastAccess" :checked="filters.fastAccess"/>
              </div>

              <div v-if="searchtype == RENTALOBJECT_TYPES.PARKING" class="vacantParkings form-group">
                <div>
                  <div class="search-module__vehicletype">
                    <div class="form-group">
                      <label class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold mt-4 mb-2" for="vehicleType">Typ av fordon</label>
                      <button v-for="item in availableVehicleTypes" @click="selectVehicle(item.code)"
                              class="search-module__vehicletype__button"
                              :class="{'active': item.code == filters.vehicleType}">{{ item.caption }}
                      </button>
                    </div>
                  </div>
                  <ObjectTypes class="form-group" :objectType=searchtype v-model="filters.rentalObjectTypes"
                               v-bind:activeFilters="filters" v-bind:vehicleType="filters.vehicleType"
                               :type="RENTALOBJECT_TYPES.PARKING" v-bind:allObjects="unfiltered"/>

                  <div class="form-group" style="margin-top: 22px">
                    <label for="monthRent">Maxhyra</label>
                    <Rent v-model="filters.maxRent" :activeType="searchtype"/>
                  </div>
                </div>
                <WaitingListType v-if="webapp_config.markerplace_filter_parking !=false"
                                 v-model="filters.waitingListType" :type="RENTALOBJECT_TYPES.PARKING"/>
              </div>

              <div>
                <div>
                  <div><a v-if="searchtype == RENTALOBJECT_TYPES.PARKING" @click="showParkingInfo = true"
                          class="information-link">Information om moms</a>
                  </div>
                </div>


                <Modal v-if="showParkingInfo && searchtype == RENTALOBJECT_TYPES.PARKING"
                       @cancel="showParkingInfo = false" confirmText="Stäng" v-on:confirm="showParkingInfo=false" cancelText="Avbryt" v-on:cancel="showParkingInfo=false">
                  <div v-html="webapp_config.msg.vacancy_parking_general_info"></div>
                </Modal>
              </div>


              <div v-if="searchtype == RENTALOBJECT_TYPES.PREMISE" class="vacantPremises">
                <div>
                  <div class="form-group mt-6 block">
                    <label for="roomCountMin">Storlek (m<sup>2</sup>)</label>
                    <div class="flex-row align-center">
                      <ObjectArea type="min" v-model="filters.minArea" :max="filters.maxArea" :activeType="searchtype"/>
                      <div class="filter-line"></div>
                      <ObjectArea type="max" v-model="filters.maxArea" :min="filters.minArea" :activeType="searchtype"/>
                    </div>
                  </div>
                  <div class="form-group" style="margin-top: 22px">
                    <label for="monthRent">Maxhyra</label>
                    <Rent v-model="filters.maxRent" :activeType="searchtype"/>
                  </div>
                  <WaitingListType v-if="webapp_config.markerplace_filter_premise !=false"
                                   v-model="filters.waitingListType" :type="RENTALOBJECT_TYPES.PREMISE"/>
                </div>
              </div>
            </div>

            <div>
              <div class="button-container flex-row space-btw">
                <button class="btn open-filters-btn" @click="showFilter = !showFilter"><span class="filter-icon"></span><span
                  v-if="showFilter" class="filter-btn-text">Stäng filter</span><span v-if="!showFilter"
                                                                                     class="filter-btn-text">Filter</span>
                  <span v-if="numFilters>0 && showFilter">( {{ numFilters }} )</span>
                </button>
                <button v-if="authStatus && (!this.subscriptionCode && this.$route.name != 'SearchPrefill')"
                        :disabled="!numFilters" class="btn-subscribe btn-subscribe--mobile"
                        v-on:click="isExpanded = !isExpanded">Skapa bevakning
                </button>
                <a
                  v-if="authStatus && numFilters>0 && (this.subscriptionCode || this.$route.name == 'SearchPrefill')"
                  class="search-module__btn-subscriptions" :href="mypagesSubscriptionsUrl">Bevakningar <span
                  class="search-module__btn-subscriptions__subscriptioncount"
                  v-if="subscriptionNewCount && subscriptionNewCount.length>0">{{ subscriptionNewCount.length }} NYA</span>
                </a>

              </div>

              <div class="search-module__subscriptions" v-if="subscriptionstring">{{ subscriptionstring }}<span
                class="search-module__subscriptions__close" @click="clear()">Stäng</span></div>

              <div>
                <a v-if="numFilters>0" class="deleteSubscription" @click="clear()">Rensa alla filter
                </a>
              </div>
            </div>

            <div class="search-module__info object-mobile">
              <div class="search-module__info__result-count">{{ result.length }} objekt</div>
              <div class="flex-row search-module__displaychoice">
                <Sort v-if="displaychoice=='list'" v-model="sortBy"/>
                <DisplayChoice v-model="displaychoice" :activeValue="displaychoice"/>
              </div>
            </div>
          </div>

          <div class="search-results">
            <Loader v-if="showResultsLoader" color="white"/>
            <Loader v-if="showLoader" :transparency="0" class="search-module__loader" />

            <div v-if="displaychoice=='list'">
              <AppendableListSearch v-if="result.length > 0" :list="result" :page="currentResultPage" :size="15"
                                    :ky="'rentalObjectCode'" :listClass="'object-list'" :itemClass="'object-item'">
                <template v-slot:default="{ item }">
                  <RentalObjectSearch :rentalObject="item" :unique="item.rentalObjectCode"/>
                </template>

                <template v-slot:more>
                  <div class="text-center gutter">
                    <router-link :to="getNextPageRoute()" class="btn btn-search">Hämta fler</router-link>
                  </div>
                </template>
              </AppendableListSearch>

              <div class="text-center gutter">
                <p v-if="showResultsLoader">Objekt laddas</p>
                <p v-if="result.length == 0 && resultsLoaded && initalLoad">Det finns tyvärr inga lediga objekt som
                  matchar din sökning just nu. Prova att bredda din sökning.</p>
              </div>

            </div>
            <div v-if="displaychoice=='map'" class="search-module__map">

              <Map v-bind:markers=result v-bind:objecttype="searchtype" />
            </div>
          </div>
          <!-- <Results :list="result" :searchType="searchtype" :page="resultPage" :size="resultChunkSize" @change="onMoreData()"/> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {isEmpty, reject, orderBy, forEach, filter} from 'lodash'
import {mapGetters, mapActions} from 'vuex'
import {toRaw} from 'vue'
import {cookieStorage} from '@/helpers/storage';

import auth from '@/auth/index'
import {RENTALOBJECT_TYPES} from '@/config/constants'
import {PARKING_FILTER_TYPES} from '@/config/constants'

import Modal from '@/components/ui/modal'
import Loader from '@/components/ui/loader'
import ObjectTypes from '@/components/search/filters_new/objecttypes'
import TownDistricts from '@/components/search/filters_new/towndistricts'
import Rent from '@/components/search/filters_new/rent'
import Rooms from '@/components/search/filters_new/rooms'
import ObjectArea from '@/components/search/filters_new/area'
import FastAccess from '@/components/search/filters_new/fastaccess'
import SearchType from '@/components/search/filters_new/searchtype'
import DisplayChoice from '@/components/search/filters_new/displaychoice'
import Sort from '@/components/search/filters_new/sort'
import SearchField from '@/components/search/filters_new/searchfield'
import WaitingListType from '@/components/search/filters_new/waitinglisttype'
import Results from '@/components/search/results'
import RentalObjectSearch from '@/components/search/rentalobjectsearch'
import AppendableListSearch from '@/components/ui/appendablelistsearch'
import CreateSubscription from '@/components/subscriptions/confirm-subscription'
import Map from '@/components/search/map'
import dayjs from 'dayjs'
import VueCookies from 'vue-cookies'
import Expandable from '@/components/ui/expandable'
import CreateForm from '@/pages/subscriptions/create-form';

export default {
  components: {
    SearchType,
    SearchField,
    DisplayChoice,
    Sort,
    ObjectTypes,
    TownDistricts,
    Rent,
    Rooms,
    FastAccess,
    ObjectArea,
    Modal,
    WaitingListType,
    Multiselect,
    Loader,
    Results,
    AppendableListSearch,
    RentalObjectSearch,
    Map,
    Expandable,
    CreateForm,
  },
  data() {
    return {
      isExpanded: false,
      showParkingInfo: false,
      showLoader: false,
      resultsLoaded: false,
      showResultsLoader: false,
      showCreateSubscriptionModal: false,
      resultChunkSize: 5,
      filterchangeCount: 0,
      displaychoice: 'list',
      sortBy: {
        title: "Senast publicerad först",
        value: "publishedFromTsDesc",
        table: "publishedFromTs",
        sortorder: "desc"
      },
      dateLimitFastAccess: null,
      numFilters: 0,
      showFilter: false,
      unfiltered: {},
      markers: [],
      initalLoad: false,
      loadedSearchtype: '',
      subscriptionCode: null,
      subscriptionstring: '',
      subscriptionNewCount: 0,
      subscriptionsConfirmedDate: {},
      timerCount: 6,
      filters: {
        administrativeUnitAreas: [],
        rentalObjectTypes: [],
        maxRent: null,
        minArea: null,
        maxArea: null,
        minRooms: null,
        maxRooms: null,
        fastAccess: null,
        waitingListType: [],
        vehicleType: '',
      },
      availableVehicleTypes: [{
        caption: 'Bil',
        code: 'CAR'
      }, {
        caption: 'Motorcykel',
        code: 'MC'
      }, {
        caption: 'Båt',
        code: 'BOAT'
      }],
      // loggedIn: false,
      PARKING_FILTER_TYPES,
      RENTALOBJECT_TYPES
    }
  },
  watch: {
    result: {
      immediate: true,
      handler(result) {
        // this.$store.dispatch('setLatestSearchResult', result);
      }
    },

    timerCount: {
      immediate: true,
      flush: 'post',
      handler(value) {
        clearInterval(this.timer);
        if (value > 0) {
          this.timer = setInterval(() => {
            if (this.timerCount > 0) {
              this.timerCount--;
            } else {
              clearInterval(this.timer);
              if (this.authStatus && this.subscriptionCode) {
                this.setSubscriptionDate();
              }
            }
          }, 1000);
        }
      }
    },

    searchtype: {
      immediate: true,
      handler(searchtype, oldValue) {
        const actionMap = {
          [RENTALOBJECT_TYPES.APARTMENT]: 'getPublishedVacantApartments',
          [RENTALOBJECT_TYPES.PARKING]: 'getPublishedVacantParkings',
          [RENTALOBJECT_TYPES.PREMISE]: 'getPublishedVacantPremises',
          [RENTALOBJECT_TYPES.STUDENT_APARTMENT]: 'getPublishedVacantApartments'
        };

        let ACTION = actionMap[searchtype];
        this.showLoader = true;

        if (searchtype !== this.filters.searchtype) {
          this.filters.searchtype = searchtype;
        }

        if (oldValue !== undefined && this.loadedSearchtype === '') {
          this.displaychoice = 'list';
          this.initalLoad = false;
          this.clear();
          // Bytt objektstyp, då gäller inte längre filtret från bevakningen
          this.clearSubscription();
          this.resultsLoaded = false;
        }

        if (ACTION) {
          this.$store.cache.dispatch(ACTION)
            .finally(() => {
              this.showLoader = false;
              this.resultsLoaded = true;
              this.loadedSearchtype = '';
            });
        } else {
          console.warn(`No action defined for searchtype: ${searchtype}`);
          this.showLoader = false;
        }
      }
    },

    filters: {
      deep: true,
      handler(filters) {
        const _filters = {};
        const prevFilters = JSON.stringify(this.$route.query);
        this.filterchangeCount++;

        Object.keys(filters).forEach(key => {
          if (key === 'rentalObjectTypes') {
            _filters[key] = filters[key].filter(Boolean); // Now just a simple filter on the array
          } else if (filters[key]) {
            _filters[key] = filters[key];
          }
        });

        const newFilters = JSON.stringify(_filters);

        if (prevFilters !== newFilters && this.subscriptionstring === '' && this.timerCount === 0) {
          this.$router.push({name: 'Search', params: {type: this.$route.params.type}});
          this.$router.replace({query: {...this.$route.query, ..._filters}});
        }

        if (this.filterchangeCount > 1 && this.timerCount === 0) {
          this.subscriptionstring = '';
          this.subscriptionCode = null;
        }
      }
    }
  },

  computed: {
    ...mapGetters([
      'publishedVacantApartments',
      'publishedVacantParkings',
      'publishedVacantPremises',
      'publishedVacantCultivationplots',
      'publishedVacantStudentApartment',
      'authStatus',
      'config',
      'webapp_config'
    ]),

    /**
     * Bevakningar ligger på Mina sidor, som är en annan app än sök ledigt
     */
    mypagesSubscriptionsUrl() {
      const myPagesUrl = (this.webapp_config?.url_to_mypages || '/mina-sidor/').replace(/\/$/, '');
      return myPagesUrl + '/#/bevakningar';
    },

    /**
     * Gör om "urlvänligt" namn till rentalobject_type
     */
    searchtype() {
      const typeMap = {
        parking: 'fordonsplatser',
        premise: 'forrad',
        apartment: 'bostad',
        cultivation: 'odlingslott'
      };


      if (this.loadedSearchtype) {
        const routeType = typeMap[this.loadedSearchtype] || this.$route.params.type;
        this.$emit('updateRoute', routeType); // Handle this in a watcher/method
        return this.loadedSearchtype;
      }

      const rentalTypeMap = {
        bostad: RENTALOBJECT_TYPES.APARTMENT,
        fordonsplatser: RENTALOBJECT_TYPES.PARKING,
        forrad: RENTALOBJECT_TYPES.PREMISE,
        studentbostader: RENTALOBJECT_TYPES.STUDENT_APARTMENT,
        odlingslott: RENTALOBJECT_TYPES.CULTIVATION
      };

      return rentalTypeMap[this.$route.params.type] || RENTALOBJECT_TYPES.APARTMENT;
    },
    /**
     * Har man fyllt i något i filtreringen?
     */

    filtersEmpty() {
      const filterValues = [
        this.filters.administrativeUnitAreas,
        this.filters.rentalObjectTypes,
        this.filters.waitingListType,
        this.filters.minRooms,
        this.filters.maxRooms,
        this.filters.minArea,
        this.filters.maxArea,
        this.filters.fastAccess,
        this.filters.keyword
      ];

      return filterValues.every(value => isEmpty(value) || !value);
    },

    /**
     * Vilken sida i pagineringen är jag på just nu?
     */
    currentResultPage() {
      return this.$route.query.page ? Number(this.$route.query.page) : 1
    },


    /**
     * Filtrerat sökresultat
     */
    result() {
      let result = [];
      let filtercount = this.filters.administrativeUnitAreas.length + Object.keys(this.filters.rentalObjectTypes).length + this.filters.waitingListType.length;
      if (this.filters.minRooms) filtercount++;
      if (this.filters.maxRooms) filtercount++;
      if (this.filters.minArea) filtercount++;
      if (this.filters.maxArea) filtercount++;
      if (this.filters.fastAccess) filtercount++;
      if (this.filters.maxRent) filtercount++;


      this.numFilters = filtercount;

      switch (this.searchtype) {
        case RENTALOBJECT_TYPES.APARTMENT:
          result = this.publishedVacantApartments;
          break;
        case RENTALOBJECT_TYPES.CULTIVATION:
          result = this.publishedVacantCultivationplots;
          break;
        case RENTALOBJECT_TYPES.PARKING:
          if (this.publishedVacantParkings == null || this.publishedVacantParkings.length < 1) result = this.publishedVacantParkings;
          else {
            result = this.publishedVacantParkings; /*.filter(item =>
                this.filters.vehicleType
                  ? PARKING_FILTER_TYPES[this.filters.vehicleType]?.includes(item.rentalObjectType)
                  : true
              );*/
          }
          break;
        case RENTALOBJECT_TYPES.PREMISE:
          result = this.publishedVacantPremises;
          break;
        case RENTALOBJECT_TYPES.STUDENT_APARTMENT:
          result = this.publishedVacantStudentApartment;
          break;
      }

      this.setInitalLoad();
      this.unfiltered = result;

      if (!Array.isArray(toRaw(result))) return [];
      // Apply filters


      const filtered = result.filter(item => {
        if (
          (this.filters?.administrativeUnitAreas?.length ?? 0) > 0 &&
          !this.filters.administrativeUnitAreas
            .map(a => a?.toLowerCase() ?? "")
            .includes(item.area?.toLowerCase() ?? "")
        ) {
          return false;
        }
        if (this.filters.keyword && !this.matchKeyword(item)) return false;
        if (this.filters.rentalObjectTypes.length > 0 && !this.filters.rentalObjectTypes.includes(item.rentalObjectType)) return false;
        if (this.filters.maxRent && item.monthRent >= this.filters.maxRent) return false;
        if (this.filters.minRooms && item.roomCount < this.filters.minRooms) return false;
        if (this.filters.maxRooms && item.roomCount > this.filters.maxRooms) return false;
        if (this.filters.minArea && item.quantityBRA < this.filters.minArea) return false;
        if (this.filters.maxArea && item.quantityBRA >= this.filters.maxArea) return false;
        if (this.filters.fastAccess && !dayjs(item.vacantFrom).isBefore(dayjs().add(14, 'days'))) return false;

        const waitingListType = item.waitingListType.replace('(endast torget)', '').trim();
        if (this.filters.waitingListType.length && !this.filters.waitingListType.includes(waitingListType)) return false;

        return true;
      });


      if (this.subscriptionstring && this.subscriptionsConfirmedDate?.[this.subscriptionCode]) {
        const subDate = dayjs(this.subscriptionsConfirmedDate[this.subscriptionCode]);
        this.subscriptionNewCount = filtered.filter(item => subDate.isBefore(dayjs(item.publishedFrom)));
      }

      let sort = this.getSortInfoByValue(this.sortBy?.value || this.sortBy);
      return this.sortBy
        ? orderBy(filtered, [sort.table], [sort.sortorder])
        : filtered;
    }
  },

  created() {
    this.scrollToTop();
    this.showLoader = true;
    if (this.$route.name != 'SearchPrefill') {
      if (isEmpty(this.$route.query) || !this.$route.query.vehicleType) {
        this.filters.vehicleType = 'CAR';
      } else {
        this.setFilters(this.$route.query);
      }
    } else {
      //get stored cookie
      this.subscriptionCode = this.$route.params.code;
      this.subscriptionsConfirmedDate = cookieStorage.getItem('subscriptionsConfirmedDate');
      if (this.subscriptionsConfirmedDate) this.subscriptionsConfirmedDate = JSON.parse(this.subscriptionsConfirmedDate);
    }

    return this.$store.cache.dispatch('getConfig').then(async () => {
      /**
       * Om man kommer från en bevakning så
       * Fyller i sökfälten med data från vald bevakning
       */

      // checkAuthStatus är asynkron och hinner oftast inte bli klar här,
      // så vänta in den innan vi avgör om bevakningen ska hämtas.
      if (this.subscriptionCode && this.authStatus === null) {
        await this.$store.dispatch('checkAuthStatus');
      }

      //this.subscriptionCode = '22-027539'; //
      if (this.authStatus && this.subscriptionCode) {
        return this.$store.cache.dispatch('fetchSingleSubscriptionByCode', this.subscriptionCode).then((subscription) => {
          // params.type ska vara det urlvänliga namnet (se searchtype), annars faller sidan tillbaka på bostad
          // när loadedSearchtype nollställs och filtren rensas.
          const urlFriendlyTypes = {
            [RENTALOBJECT_TYPES.APARTMENT]: 'bostad',
            [RENTALOBJECT_TYPES.PARKING]: 'fordonsplatser',
            [RENTALOBJECT_TYPES.PREMISE]: 'forrad',
          };
          this.$route.params.type = urlFriendlyTypes[subscription.objectType] || this.$route.params.type;
          this.loadedSearchtype = subscription.objectType;
          let temp = subscription.rentalObjectTypes[0] ? subscription.rentalObjectTypes[0] : subscription.rentalObjectTypes;
          let select = '';
          if (subscription.waitingListTypeCaption?.match('Prenumeration, student')) {
            this.$route.params.type = 'studentbostader';
            this.loadedSearchtype = RENTALOBJECT_TYPES.STUDENT_APARTMENT;
          } else if (subscription.objectType == 'parking') {
            subscription.vehicleType = 'CAR';
            this.filters.vehicleType = 'CAR';
            this.selectVehicle('CAR');
          } else if (subscription.objectType == 'cultivation') {
            this.$route.params.type = 'odlingslott';
            this.loadedSearchtype = 'odlingslott';
          }

          if (typeof temp === 'String') {
            if (PARKING_FILTER_TYPES['CAR'].includes(temp)) select = 'CAR';
            else if (PARKING_FILTER_TYPES['MC'].includes(temp)) select = 'MC';
            else if (PARKING_FILTER_TYPES['CV'].includes(temp)) select = 'CV';
            else if (PARKING_FILTER_TYPES['BOAT'].includes(temp)) select = 'BOAT';
            this.filters.vehicleType = select;
            this.selectVehicle(select);
            subscription.vehicleType = select;
          }

          this.setFilters(subscription, true);
        }).finally(() => {
          this.showLoader = false
          this.setInitalLoad();
        })

        /**
         * Fyller i filtering från URL. Om det finns någon.
         */
      } else if (isEmpty(this.$route.query)) {
        this.showLoader = false
        this.setInitalLoad();
      }

    }).finally(() => {
      this.showLoader = false
      this.setInitalLoad();
    })

  },

  methods: {
    getSortInfoByValue(value) {
      const match = this.config.sortOptions.find(option => option.value === value);
      if (match) {
        return {
          table: match.table,
          sortorder: match.sortorder
        };
      }
      return null;
    },
    matchKeyword(item) {
      if (!this.filters.keyword) return true;

      const keywords = this.filters.keyword.toLowerCase().split(" ");
      return keywords.every(word =>
        [item.address, item.neighbourhood, item.caption, item.rentalObjectTypeName, item.subCaption]
          .some(field => field?.toLowerCase().includes(word))
      );
    },

    setInitalLoad() {
      setTimeout(() => {
        this.initalLoad = true;
        clearTimeout();
      }, 700);
    },

    closeModal() {
      document.removeEventListener('keyup', this._keyUpListeners);
      document.querySelector('html').classList.remove('modal-open');
      this.showCreateSubscriptionModal = false;
    },

    setSubscriptionDate() {
      if (!this.subscriptionsConfirmedDate || (this.subscriptionsConfirmedDate && dayjs(this.subscriptionsConfirmedDate[this.subscriptionCode]).diff(dayjs(new Date()).format('YYYY-MM-DD')) != 0)) {
        this.subscriptionsConfirmedDate = {
          [this.subscriptionCode]: dayjs(new Date()).format('YYYY-MM-DD')
        }

        VueCookies.set("subscriptionsConfirmedDate", JSON.stringify(this.subscriptionsConfirmedDate), 60 * 60 * 24 * 90); //expires in 90 days

        // this.$store.cache.dispatch('setSubscriptionsViewed', this.subscriptionsConfirmedDate);
      }
    },

    selectVehicle(itemCode) {
      this.filters.vehicleType = itemCode;
      this.clearRentalObjectTypes();
    },

    /**
     * Route till nästa sida i pagineringen, inkl filtrering.
     */
    getNextPageRoute() {
      return {
        name: 'Search',
        params: {type: this.$route.params.type || 'bostad'},
        query: {...this.$route.query, page: (this.currentResultPage + 1)}
      }
    },
    scrollToTop() {
      if (document.getElementById('errors-list')) document.getElementById('errors-list').scrollIntoView();
    },

    /**
     * Sätter filter.
     * Används när man kommer från en bevakning, eller om man angett filtreringen i urlen.
     */
    setFilters(filters, isSubscription) {
      /**
       * Ersätter arrayen på ett sätt så att Vue fattar
       * men om värdet inte skickas in flera ggr typ rentalObjectTypes=LGH3&rentalObjectTypes=LGH4
       * måste den göras till array först
       */
      if (Array.isArray(filters.administrativeUnitAreas)) {
        filters.administrativeUnitAreas.forEach(o => {
          this.filters.administrativeUnitAreas.push(o)
        })
      } else if (typeof filters.administrativeUnitAreas === 'string') {
        this.filters.administrativeUnitAreas.push(filters.administrativeUnitAreas)
      }

      /**
       * Ersätter arrayen på ett sätt så att Vue fattar..
       * men om värdet inte skickas in flera ggr typ rentalObjectTypes=LGH3&rentalObjectTypes=LGH4
       * måste den göras till array först
       */
      if (Array.isArray(filters.rentalObjectTypes)) {
        filters.rentalObjectTypes.forEach(o => {
          this.filters.rentalObjectTypes.push(o)
        })
      } else if (typeof filters.rentalObjectTypes === 'string') {
        this.filters.rentalObjectTypes.push(filters.rentalObjectTypes)
      }

      /**
       * Ersätter arrayen på ett sätt så att Vue fattar..
       * men om värdet inte skickas in flera ggr typ ?waitingListType=Torget,%20förråd&waitingListType=Direkt,%20förråd
       * måste den göras till array först
       */
      if (Array.isArray(filters.waitingListType)) {
        filters.waitingListType.forEach(o => {
          this.filters.waitingListType.push(o)
        })
      } else if (typeof filters.waitingListType === 'string') {
        this.filters.waitingListType.push(filters.waitingListType)
      }

      //this.sortBy = this.sortBy
      this.filters.maxRent = parseInt(filters.maxRent)
      this.filters.minRooms = parseInt(filters.minRooms)
      this.filters.maxRooms = parseInt(filters.maxRooms)
      this.filters.fastAccess = filters.fastAccess
      this.filters.minArea = parseInt(filters.minArea)
      this.filters.maxArea = parseInt(filters.maxArea)
      this.filters.vehicleType = filters.vehicleType;

      this.subscriptionstring = '';

      if (isSubscription) {
        if (this.filters.administrativeUnitAreas.length > 0) this.subscriptionstring = this.filters.administrativeUnitAreas.join(', ') + ", ";
        if (this.filters.rentalObjectTypes.length > 0) {
          if (this.searchtype == 'parking') {

            this.filters.rentalObjectTypes.forEach((value, index) => {
              let tempStr = filter(this.$store.getters.config.vehicleSpaceTypes, (vehicleSpaceType) => {
                if (value == vehicleSpaceType.code) {
                  this.subscriptionstring += vehicleSpaceType.caption + ", ";
                  return true;
                }
              });
            });


          } else {

            this.filters.rentalObjectTypes.forEach((value, index) => {
              let tempStr = filter(this.$store.getters.config.rentalObjectTypes, (spaceType) => {
                if (value == spaceType.code) {
                  this.subscriptionstring += spaceType.caption + ", ";
                  return true;
                }
              });
            });

            //this.subscriptionstring += this.filters.rentalObjectTypes.join(', ') + ", ";
          }

        }
        if (this.filters.maxRent > 0) this.subscriptionstring += this.filters.maxRent + 'kr/mån, ';
        if (this.filters.minArea) this.subscriptionstring += "Min " + this.filters.minArea + 'm², ';
        if (this.filters.maxArea) this.subscriptionstring += "Max " + this.filters.maxArea + 'm², ';
        if (this.filters.minRooms && this.filters.maxRooms) this.subscriptionstring += this.filters.minRooms + ' - ' + this.filters.maxRooms + ' rok, ';
        else if (this.filters.minRooms) this.subscriptionstring += 'Minst ' + this.filters.minRooms + ' rok, ';
        else if (this.filters.maxRooms) this.subscriptionstring += 'Max ' + this.filters.maxRooms + ' rok, ';

        this.subscriptionstring = this.subscriptionstring.slice(0, -2);
      }
    },

    /**
     * Rensar all filtrering
     */
    clear() {
      this.filters = {
        administrativeUnitAreas: [],
        rentalObjectTypes: [],
        maxRent: null,
        minArea: null,
        minRooms: null,
        maxRooms: null,
        fastAccess: false,
        waitingListType: [],
        vehicleType: ''
      }
      if (this.searchtype == 'parking') this.filters.vehicleType = 'CAR';
      else this.filters.vehicleType = '';

      this.loadedSearchtype = '';
      this.resultChunkSize = 15

      // Ta bort page från URL
      let query = {...query}
      delete query.page

      const allowedKeys = ['vehicleType', 'searchtype'];
      const currentQuery = this.$route.query;

      const filteredQuery = Object.fromEntries(
        Object.entries(currentQuery).filter(([key]) => allowedKeys.includes(key))
      );

      this.$router.replace({
        name: 'Search',
        params: { type: this.$route.params.type },
        query: filteredQuery
      });
    },

    clearSubscription() {
      this.subscriptionstring = '';
      this.subscriptionCode = null;
      this.subscriptionNewCount = 0;
    },

    clearRentalObjectTypes() {
      this.filters.rentalObjectTypes = [];

      // Ta bort page från URL
      let query = {...query}
      delete query.page

      this.$router.push({name: 'Search', params: {type: this.$route.params.type}, query})
    },

    onMoreData() {
      this.showLoader = true

      setTimeout(() => {
        this.showLoader = false
      }, 1000)
    },

    toggle() {

    },
  }
}
</script>
<!--
    New step!
    Add Multiselect CSS. Can be added as a static asset or inside a component.
-->


<!-- Add "scoped" attribute to limit CSS to this component only -->

<!-- student: item.RentalObjectTypeCode == 'LGH20',
  tryggboplus: item.RentalObjectTypeCode == 'LGH4',
  tryggbo: item.RentalObjectTypeCode == 'LGH2',
  nyproduktion: item.RentalObjectTypeCode == 'LGH9',
  startbo: item.RentalObjectTypeCode == 'LGH5'}" -->


<style lang="scss">

.search-module {
  margin-bottom: 50px;

  .segmented-control input[type=radio]:checked + label,
  .segmented-control input[type=checkbox]:checked + label {
    background-color: $abgyellow;
  }

  &__preamble {
    max-width: 700px;
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 26px;
    font-family: $sansserif;
    font-weight: 500;

    @media (min-width: 600px) {
      font-size: 22px;
    }


    a, a:visited {
      color: $abgblue;
    }
  }

  &__link {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 16px;
    text-decoration: none !important;
    color: black !important;
    padding: 16px 55px 16px 16px; // 12px 11px 16px;
    background-color: #fff;
    border-radius: 4px;
    border: solid 1px $lightgray;
    margin-bottom: 35px;
    transition: all 0.2s;
    position: relative;

    &:hover, &:focus {

      &:after {
        background-color: $abglightblue;
        width: 34px;
        height: 34px;
        right: 9px;
      }
    }

    &:before {
      position: absolute;
      right: 26px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-left: 20px;
      content: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-arrow.svg);
      width: 1px;
      height: 1px;
      transition: all 0.3s;
      padding-top: 0 !important;
      margin-top: 5px;
      z-index: 2;
    }

    &:after {
      position: absolute;
      content: "";
      right: 26px;
      background-color: #fff;
      border-radius: 50%;
      width: 1px;
      height: 1px;
      transition: all 0.3s;
    }

    @media (min-width: 600px) {
      display: inline-flex;
    }
  }

  &__vehicletype {
    margin-bottom: 20px;

    label {
      text-transform: uppercase;
      font-size: 14px;
      letter-spacing: 0.42px;
      font-weight: 600;
      margin-bottom: 8px;
      display: block !important;
    }

    button {
      border-radius: 4px;
      color: $abgblue;
      background-color: $abglightblue;
      margin: 0 8px 8px 0;
      padding: 12px 20px;
      border: none;
      outline: none;
      font-size: 15px;
      font-weight: bold;
      cursor: pointer;
      letter-spacing: 0.18px;

      &.active {
        background-color: $abgblue;
        color: $textcolorwhite;
      }

      &:hover {
        border: 1px solid $abgblue;
        padding: 11px 19px;
      }
    }

  }

  &__btn-subscriptions {
    position: relative;
    padding: 10px 24px 11px 22px;
    border-radius: 6px;
    background-color: $abgblue;
    color: $textcolorwhite;
    letter-spacing: 0.18px;
    font-size: 15px;
    font-weight: bold;
    text-transform: none;
    display: flex;
    align-items: center;
    line-height: 25px;
    margin: 0;
    text-decoration: none;
    border: none;

    @media (min-width: 1024px) {
      margin: 0 0 10px 0;
      color: $abgblue;
      border-radius: 6px;
      border: solid 2px $abgblue;
      background-color: transparent;
      width: 100%;
      display: flex;
      justify-content: center;

      &:hover {
        background-color: $abgblue;
        color: #fff;
        transition: all 0.2s;
      }
    }

    &__subscriptioncount {
      background-color: $abgyellow;
      border-radius: 2px;
      color: #000;
      padding: 3px 5px 3px 5px;
      line-height: 1;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      position: absolute;
      top: -10px;
      right: -7px;
    }
  }

  sup {
    vertical-align: super;
    font-size: 0.8rem;
    font-weight: 700;
  }

  &__loader {
    position: absolute !important;
    left: 50%;

    @media (min-width: 1020px) {
    }
  }
}

label {
  font-family: $headingfont;
}

.multiselect__placeholder {
  padding-top: 4px !important;
  position: relative;
}

.multiselect {
  border: unset;
}

.multiselect--active input {
  visibility: visible;
}

.multiselect__content-wrapper {
  overflow: auto !important;

  .multiselect__content {
    // overflow: hidden;
    position: relative !important;
  }
}

.search-result {
  margin-top: 5em;
}

.deleteSubscription {
  cursor: pointer;
  color: $abgblue;
  font-size: 15px;
  letter-spacing: 0.38px;
  text-decoration: none;
  font-weight: bold;
  margin: 15px 0;
  display: inline-block;
  position: relative;

  @media (min-width: 1024px) {
    margin-top: 8px;
  }

  &:before {
    content: '';
    background-color: $abglightblue;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    position: absolute;
    right: -36px;
    top: -6px;
  }

  &:after {
    content: '';
    mask-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-cross2.svg);
    background-color: $abgblue;
    mask-size: 18px 18px;
    mask-repeat: no-repeat;
    position: absolute;
    right: -31px;
    top: -1px;
    width: 18px;
    height: 18px;
  }
}

.center {
  margin-left: 50%;
}

.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

.sortSelect.multiselect {
  min-width: 180px;
  min-height: 47px;

  > div {
    min-height: 47px;
  }
}

.sortSelect {
  .multiselect__input, .multiselect__single {
    line-height: 22px;
    font-size: 16px;
    font-weight: 600;
  }

  .multiselect__select:before {
    border-color: #000 transparent transparent
  }

  .multiselect__tags {
    border: none;
    padding: 9px 28px 0 10px;
    border-radius: 4px;

    @media (min-width: 768px) {
      padding: 9px 40px 0 10px;
    }
  }
}


.multiselect__option--selected {
  background: $abgblue !important;
  color: $textcolorwhite !important;
  font-weight: 700;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: $abgblue !important;
  color: $textcolorwhite !important;
}

.multiselect__option--highlight {
  background: $abglightblue !important;
  color: $abgblue !important;
}

.multiselect__option {
  font-size: 15px;
}
</style>

<style scoped lang="scss">

.search-module {
  width: 100vw;
  margin-left: calc((100% - 100vw) / 2);
  padding: 0;

  @media (min-width: 768px) {
    padding: 0;
  }

  &__subscriptions {
    position: relative;
    display: inline-block;
    font-size: 14px;
    color: $abgblue;
    line-height: 17px;
    padding: 5px 36px 5px 8px;
    background-color: $abglightblue;
    border-radius: 4px;
    max-width: 266px;
    margin-top: 24px;

    @media (min-width: 768px) {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    &__close {
      text-indent: -9999px;
      overflow: hidden;
      cursor: pointer;
      content: '';
      position: absolute;
      right: 8px;
      top: calc(50% - 9px);
      mask-size: contain;
      mask-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-cross.svg);
      background-color: $abgblue;
      width: 18px;
      height: 18px;
    }
  }
}

.search-module__header {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 15px;

  @media (min-width: 800px) {
    padding: 0 45px;
  }

  @media (min-width: 1320px) {
    padding: 0 15px;
  }
}

.search-module__wrapper {
  background-color: $offwhite;
  border-top: 2px solid $lightgray;
  margin-top: -2px;
}

.search-module__main-container {
  position: relative;
  max-width: 1280px;
  margin: 0 auto;
  padding: 30px 15px;

  @media (min-width: 800px) {
    padding: 30px 45px;
  }

  @media (min-width: 1024px) {
    padding: 0px 45px 30px;
  }

  @media (min-width: 1320px) {
    padding: 0px 15px 30px;
  }
}

.search-module__map {
  position: relative;
}

.search-module__displaychoice {
  min-height: 65px;

  @media (min-width: 1024px) {
    min-height: 81px;
  }
}

.search-module__info {
  margin-top: 20px;
  padding-top: 20px;
  margin-bottom: 4px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  @media (min-width: 1024px) {
    padding-top: 0;
    flex-direction: row;
    width: calc(100% - 336px);
    align-items: center;
  }


  &.object-mobile {
    border-top: 2px solid $lightgray;
  }

  .search-module__info__result-count {
    font-size: 18px;
    font-weight: bold;
    font-family: $headingfont;
    letter-spacing: 0.48px;
    margin-top: 6px;
    margin-bottom: 16px;

    @media (min-width: 1024px) {
      margin-top: 0;
      margin-bottom: 1em;
    }
  }
}

/*.search.map {
  .search-module__info {
    position: absolute;
    padding-top: 0;
    margin-top: 0;
    top: 33px;
    right: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    z-index: 99;

    &__result-count {
      font-weight: bold;
      margin-top: 0;
      margin-right: 15px;
    }

    &.object-mobile, &.object-desktop {
      display: none;
    }
  }
}*/

.search-module__flex-container {
  position: relative;
  width: 100%;

  @media (min-width: 1024px) {
    display: flex;
    flex-direction: row-reverse;
  }
}

.btn-search {
  padding: 14px 24px;
  border-radius: 6px;
  border: solid 2px $abgblue;
  color: $abgblue;
  text-transform: none;
  font-weight: bold;
  background-color: transparent;

  &:hover, &:active, &:focus {
    color: $textcolorwhite !important;
    background: $abgblue;
    border: solid 2px $abgblue !important;
  }
}

.information-link {
  font-weight: bold;
  font-size: 15px;
  color: $abgblue;
  text-decoration: none;
  cursor: pointer;
  display: block;
  position: relative;
  margin-top: 25px;
  margin-bottom: 34px;
  display: flex;
  align-items: center;

  @media (min-width: 1024px) {
    margin-bottom: 15px;
    margin-top: 25px;
  }

  &:before {
    content: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-info.svg);
    width: 24px;
    height: 25px;
    margin-right: 8px;
  }
}

.filter-controls {
  width: 100%;

  @media (min-width: 1024px) {
    margin-top: -87px;
    width: 294px;
    margin-left: 42px;
  }
}

.open-filters-btn {
  padding: 10px 24px 11px 22px;
  border-radius: 6px;
  background-color: $abgblue;
  color: $textcolorwhite;
  letter-spacing: 0.18px;
  font-size: 15px;
  font-weight: bold;
  text-transform: none;
  display: flex;
  align-items: center;
  line-height: 25px;
  margin: 12px 0 0 0;

  @media (min-width: 1024px) {
    display: none;
  }

  span {
    font-weight: bold;
  }
}

.open-filters-btn.open {
  .filter-icon {
    display: none;
  }
}

.filter-icon {
  width: 24px;
  height: 24px;
  background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-filter.svg);
  margin-right: 8px;
}


.btn-subscribe {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.15px;
  border: none;
  outline: none;
  padding: 0;
  background-color: transparent;
  color: $abgblue;
  position: relative;
  cursor: pointer;
  margin-left: 32px;

  &--desktop {
    display: none;
  }

  @media (min-width: 1024px) {
    margin-top: 12px;
    margin-bottom: 3.3rem;
    margin-left: 0;

    &--mobile {
      display: none;
    }

    &--desktop {
      display: flex;
    }
  }

  &:not(:disabled):hover {
    text-decoration: underline;
  }

  &:before {
    margin-right: 12px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3E%3Cpath stroke='%23007893' stroke-width='2' d='M12 1.987l2.793 4.796c.283.485.757.83 1.305.948l5.425 1.175-3.698 4.139c-.374.418-.555.975-.498 1.534l.559 5.522-5.08-2.238c-.513-.227-1.099-.227-1.612 0L6.114 20.1l.56-5.522c.056-.559-.125-1.116-.499-1.534l-3.698-4.14 5.425-1.174c.548-.119 1.022-.463 1.305-.948L12 1.987z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    width: 24px;
    height: 24px;
    content: '';
  }

  &:disabled {
    color: $gray;
    cursor: default;

    &:before {
      content: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-star-disabled.svg);
    }
  }
}

label {
  display: inline-block;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 0.42px;
  font-weight: 600;
  margin-bottom: 8px;
}

.filterAccordion {
  max-height: 0;
  transition: max-height 0.15s ease-out;
  overflow: hidden;

  @media (min-width: 1024px) {
    max-height: initial;
    overflow: visible;
  }

  &.showFilter {
    max-height: initial;
    transition: max-height 0.25s ease-in;
  }
}

.search-results {
  width: 100%;
  position: relative;

  @media (min-width: 1024px) {
    width: calc(100% - 336px);
  }
}

.flex-row {
  display: flex;
  flex-direction: row;

  &.align-center {
    //align-items: center;
  }

  &.space-btw {
    justify-content: space-between;
  }
}

.button-container {
  align-items: center;
  margin-top: 0;


}

.filter-line {
  width: 10px;
  height: 1px;
  margin: 20px 6px 0px;
  background-color: $abgblue;
}

.object-desktop {
  display: none;
  @media (min-width: 1024px) {
    display: flex;
  }
}

.object-mobile {
  display: flex;
  flex-direction: column;
  @media (min-width: 600px) {
    flex-direction: row;
  }

  @media (min-width: 1024px) {
    display: none;
  }
}

.scrolltop-btn {
  position: absolute;
  right: 0;
  border: none;
  outline: none;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  background-color: $abglightblue;
  cursor: pointer;
  transition: all 0.3s;

  span {
    border: solid $abgblue;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }

  &:hover {
    background-color: $abgblue;

    span {
      border-color: $textcolorwhite;
    }
  }
}

.createform {
  @media (min-width: 768px) {
    padding: 40px !important;
  }
}

.collapsible-body {
  position: absolute;
  z-index: 1;
  margin: 15px;
  left: 0;
  top: -80px;
  width: calc(100% - 30px);
  max-width: 620px;

  @media (min-width: 768px) {
    left: calc(50% - 400px);
  }

  .expanded &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .4);
    z-index: -1;
  }

  .expanded &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $backgroundcolorwhite;
    border-radius: 4px;
    box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.1);
    z-index: 0;
  }

  .unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}


.form-group {
  margin-bottom: 20px;

  @media (min-width: 1024px) {
    margin-bottom: 8px;
  }
}

.filter-btn-text {
  letter-spacing: 0.18px;
}
</style>
